"use client";

import { signOut } from "next-auth/react";

export function SignOutButton() {
  return (
    <button
      onClick={() => signOut({ callbackUrl: "/login" })}
      className="kicker rounded px-3 py-1.5 text-left hover:bg-white/5 hover:text-foreground"
    >
      Выйти
    </button>
  );
}
